<template lang="pug">
.composition.composition--flush-bottom.composition--padded
	.refine
		button.refine__toggle.btn(type="button") Refine Results
		.refine__inner
			.refine__content
				button.refine__close(type="button") Close
				p.refine__results 54 Results
				form.refine__form
					.refine__group(:key='filterGroup.id' v-for='(filterGroup, i) in visibleFilters')
						.refine__title(tabindex="0" role="button") {{filterGroup.name}}
						.refine__options
							.refine__options-inner
								.refine__option(:key='filter.id' v-for='filter in filterGroup.filters')
									div(v-if='filter.count > 0')
										input.refine__input(type='checkbox', v-model='filter.selected' :id='filter.id')
										label.refine__label(:for='filter.id') {{getFilterText(filter)}}
								
					
					button.btn.refine__btn(@click='submitFilters') {{settings.filterButtonText}}



//- .filters(v-bind:class="{'filters--active': mobileOpen}")
//-   button.filters__toggle.btn(type='button' @click='mobileOpen = !mobileOpen') {{settings.filterText}}
//-   .filters__inner(@click.self='mobileOpen = false')
//-     .filters__content
//-       button.filters__close(type='button' @click='mobileOpen = false') Close
//-       p.filters__heading {{settings.filterText}}
//-       .filters__form
//-         .filters__group(:key='filterGroup.id' v-for='(filterGroup, i) in visibleFilters')
//-           .filters__title(tabindex='0' role='button' @click='toggleFilter($event, i)' :data-active='filterState[i]') {{filterGroup.name}}
//-           app-transition-expand
//-             .filters__options(v-if='filterState[i]' :data-active='filterState[i]')
//-               .filters__options-inner
//-                 .filters__option(:key='filter.id' v-for='filter in filterGroup.filters')
//-                   div(v-if='filter.count > 0')
//-                     input.filters__input(type='checkbox', v-model='filter.selected' :id='filter.id')
//-                     label.filters__label(:for='filter.id') {{getFilterText(filter)}}
//-         button.filters__btn.btn.btn--ghost(@click='submitFilters') {{settings.filterButtonText}}
</template>

<script>
    import TransitionExpand from './global/TransitionExpand';
    export default {
        components: {
            appTransitionExpand: TransitionExpand
        },
        data: function () {
            return {
                loaded: false,
                mobileOpen: false,
                filterState: []
            }
        },
        watch: {
            filters() {
                let filterState = [];
                this.filters.forEach(() => {
                    filterState.push(true);
                });
                this.filterState = filterState;

                if (!this.loaded && this.$route.query.c && this.filters.length > 0) {
                    var f = JSON.parse(JSON.stringify(this.filters));
                    this.updateFiltersFromQuerystring(this.$route.query.c, f);

                    this.$emit('submitFilters', f);
                     this.loaded = true;
                }
            }
        },
        computed: {
            filters: function () {
                return this.$store.state.results.filters;
            },
            settings: function () {
                return this.$store.state.settings;
            },
            visibleFilters: function() {
                return this.filters.filter(f => f.visible == true);
            }


        },
        methods: {
            toggleFilter(e, i) {
                const filterState = [...this.filterState];
                filterState[i] = !filterState[i];
                this.filterState = filterState;
            },
            submitFilters: function () {
                this.$emit('submitFilters', this.filters);
            },
            updateFiltersFromQuerystring(query, filters) {
                var ids = query.split(',');

                ids.forEach(function (theID) {

                    filters.forEach(function (parent) {
                        var match = parent.filters.find(c => c.id === theID);

                        if (match) {
                            match.selected = true;
                        }
                    });
                });
            },
            getFilterText: function(filter) {
                return filter.value + " (" + filter.count + ")";
            }
        },
        mounted() {
            let filterState = [];
            this.filters.forEach(filterGroup => {
                filterState.push(true);
            });
            this.filterState = filterState;
        }
    }
</script>

<style lang="scss" scoped>



</style>